module.exports = __webpack_public_path__ + "img/tp-card-3.2282f6b6.png";